/**
 * @ngdoc directive
 * @name BB:bbPage
 * @restrict AE
 * @scope true
 *
 * @description
 *
 * Loads a list of page for the currently in scope company
 *
 * <pre>
 * restrict: 'AE'
 * replace: true
 * scope: true
 * </pre>
 */
(function () {
    'use strict';

    angular.module('BBPublicBooking').directive('bbPage', () => {
        'ngInject';

        return {
            restrict: 'AE',
            replace: true,
            scope: true,
            controller: 'BBPageCtrl',
            controllerAs: '$bbPageCtrl'
        };
    });

})();



// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/public-booking/page/bb_page.directive.js